import { SVGProps } from 'react';
const SvgArrowRightMd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 12H5M11 18l-6-6 6-6"
    />
  </svg>
);
export default SvgArrowRightMd;
